import type { LiveEvent } from '@setplex/tria-api'
import type { Store } from 'effector'

import { api } from '@setplex/tria-api'
import { genPagesLogic } from '~/shared/effector'

export const $upcomingEvents: Store<LiveEvent[]> =
  api.liveEvents.$upcomingEvents

export const loadMoreUpcomingEvents = genPagesLogic(
  api.liveEvents.$upcomingEventsPageInfo,
  api.liveEvents.loadUpcomingEventsFx
)
